module.exports = __webpack_public_path__ + "img/record.61dfb6e.svg";